// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 667) return "assets/_frontend/build/frontend/toastrBundle.js?id=9e3eea6138e573dd";
	if (chunkId === 132) return "assets/_frontend/build/frontend/ionRangeSliderBundle.js?id=b597be56ff563c5e";
	if (chunkId === 625) return "assets/_frontend/build/frontend/yandexMap.js?id=b960ff79a6fcddaf";
	if (chunkId === 883) return "assets/_frontend/build/frontend/vgMap.js?id=a61e0d66592c6904";
	if (chunkId === 924) return "assets/_frontend/build/frontend/catalogFilters.js?id=2c36d4e57f6b606e";
	if (chunkId === 301) return "assets/_frontend/build/frontend/catalogOrder.js?id=2be8f7c8d11eb98e";
	if (chunkId === 464) return "assets/_frontend/build/frontend/fancyboxBundle.js?id=5eddc049acc6addc";
	if (chunkId === 660) return "assets/_frontend/build/frontend/rollupBundle.js?id=fd5997aecf3bde96";
	if (chunkId === 822) return "assets/_frontend/build/frontend/inputmask.js?id=ebf67c1bd8804765";
	// return url for filenames based on template
	return undefined;
};